/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AtualizarCargoDoAmbienteDto,
  CargoDoAmbienteResponse,
  CatalogoDePermissoesDoAmbienteResponse,
  ConviteResponse,
  CriarCargoDoAmbienteDto,
  CriarConviteDto,
  DefinirAtivoDoMembroDto,
  DefinirCargoDoMembroDto,
  DefinirPermissoesDoAmbienteDto,
  ErroResponse,
  MembroDoAmbienteResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAmbienteControllerListarMembrosUrl = () => {




  return `/v1/ambiente/membros`
}

/**
 * @summary Lista os membros do ambiente
 */
export const ambienteControllerListarMembros = async ( options?: Parameters<typeof httpClient>[1]): Promise<MembroDoAmbienteResponse[]> => {

  return httpClient<MembroDoAmbienteResponse[]>(getAmbienteControllerListarMembrosUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAmbienteControllerListarMembrosQueryKey = () => {
    return [
    `/v1/ambiente/membros`
    ] as const;
    }


export const getAmbienteControllerListarMembrosQueryOptions = <TData = Awaited<ReturnType<typeof ambienteControllerListarMembros>>, TError = ErroResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerListarMembros>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAmbienteControllerListarMembrosQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof ambienteControllerListarMembros>>> = ({ signal }) => ambienteControllerListarMembros({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerListarMembros>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AmbienteControllerListarMembrosQueryResult = NonNullable<Awaited<ReturnType<typeof ambienteControllerListarMembros>>>
export type AmbienteControllerListarMembrosQueryError = ErroResponse


export function useAmbienteControllerListarMembros<TData = Awaited<ReturnType<typeof ambienteControllerListarMembros>>, TError = ErroResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerListarMembros>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ambienteControllerListarMembros>>,
          TError,
          Awaited<ReturnType<typeof ambienteControllerListarMembros>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAmbienteControllerListarMembros<TData = Awaited<ReturnType<typeof ambienteControllerListarMembros>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerListarMembros>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ambienteControllerListarMembros>>,
          TError,
          Awaited<ReturnType<typeof ambienteControllerListarMembros>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAmbienteControllerListarMembros<TData = Awaited<ReturnType<typeof ambienteControllerListarMembros>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerListarMembros>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os membros do ambiente
 */

export function useAmbienteControllerListarMembros<TData = Awaited<ReturnType<typeof ambienteControllerListarMembros>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerListarMembros>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAmbienteControllerListarMembrosQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAmbienteControllerDefinirCargoDoMembroUrl = (profileId: string,) => {




  return `/v1/ambiente/membros/${profileId}/cargo`
}

/**
 * @summary Troca o cargo de um membro
 */
export const ambienteControllerDefinirCargoDoMembro = async (profileId: string,
    definirCargoDoMembroDto: DefinirCargoDoMembroDto, options?: Parameters<typeof httpClient>[1]): Promise<MembroDoAmbienteResponse[]> => {

  return httpClient<MembroDoAmbienteResponse[]>(getAmbienteControllerDefinirCargoDoMembroUrl(profileId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(definirCargoDoMembroDto)
  }
);}





export const getAmbienteControllerDefinirCargoDoMembroMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerDefinirCargoDoMembro>>, TError,{profileId: string;data: DefinirCargoDoMembroDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerDefinirCargoDoMembro>>, TError,{profileId: string;data: DefinirCargoDoMembroDto}, TContext> => {

const mutationKey = ['ambienteControllerDefinirCargoDoMembro'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ambienteControllerDefinirCargoDoMembro>>, {profileId: string;data: DefinirCargoDoMembroDto}> = (props) => {
          const {profileId,data} = props ?? {};

          return  ambienteControllerDefinirCargoDoMembro(profileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AmbienteControllerDefinirCargoDoMembroMutationResult = NonNullable<Awaited<ReturnType<typeof ambienteControllerDefinirCargoDoMembro>>>
    export type AmbienteControllerDefinirCargoDoMembroMutationBody = DefinirCargoDoMembroDto
    export type AmbienteControllerDefinirCargoDoMembroMutationError = ErroResponse

    /**
 * @summary Troca o cargo de um membro
 */
export const useAmbienteControllerDefinirCargoDoMembro = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerDefinirCargoDoMembro>>, TError,{profileId: string;data: DefinirCargoDoMembroDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ambienteControllerDefinirCargoDoMembro>>,
        TError,
        {profileId: string;data: DefinirCargoDoMembroDto},
        TContext
      > => {
      return useMutation(getAmbienteControllerDefinirCargoDoMembroMutationOptions(options), queryClient);
    }
    export const getAmbienteControllerDefinirAtivoDoMembroUrl = (profileId: string,) => {




  return `/v1/ambiente/membros/${profileId}/ativo`
}

/**
 * @summary Ativa ou desativa o vínculo do membro NESTE ambiente
 */
export const ambienteControllerDefinirAtivoDoMembro = async (profileId: string,
    definirAtivoDoMembroDto: DefinirAtivoDoMembroDto, options?: Parameters<typeof httpClient>[1]): Promise<MembroDoAmbienteResponse[]> => {

  return httpClient<MembroDoAmbienteResponse[]>(getAmbienteControllerDefinirAtivoDoMembroUrl(profileId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(definirAtivoDoMembroDto)
  }
);}





export const getAmbienteControllerDefinirAtivoDoMembroMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerDefinirAtivoDoMembro>>, TError,{profileId: string;data: DefinirAtivoDoMembroDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerDefinirAtivoDoMembro>>, TError,{profileId: string;data: DefinirAtivoDoMembroDto}, TContext> => {

const mutationKey = ['ambienteControllerDefinirAtivoDoMembro'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ambienteControllerDefinirAtivoDoMembro>>, {profileId: string;data: DefinirAtivoDoMembroDto}> = (props) => {
          const {profileId,data} = props ?? {};

          return  ambienteControllerDefinirAtivoDoMembro(profileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AmbienteControllerDefinirAtivoDoMembroMutationResult = NonNullable<Awaited<ReturnType<typeof ambienteControllerDefinirAtivoDoMembro>>>
    export type AmbienteControllerDefinirAtivoDoMembroMutationBody = DefinirAtivoDoMembroDto
    export type AmbienteControllerDefinirAtivoDoMembroMutationError = ErroResponse

    /**
 * @summary Ativa ou desativa o vínculo do membro NESTE ambiente
 */
export const useAmbienteControllerDefinirAtivoDoMembro = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerDefinirAtivoDoMembro>>, TError,{profileId: string;data: DefinirAtivoDoMembroDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ambienteControllerDefinirAtivoDoMembro>>,
        TError,
        {profileId: string;data: DefinirAtivoDoMembroDto},
        TContext
      > => {
      return useMutation(getAmbienteControllerDefinirAtivoDoMembroMutationOptions(options), queryClient);
    }
    export const getAmbienteControllerListarConvitesUrl = () => {




  return `/v1/ambiente/convites`
}

/**
 * @summary Lista os convites pendentes/expirados do ambiente
 */
export const ambienteControllerListarConvites = async ( options?: Parameters<typeof httpClient>[1]): Promise<ConviteResponse[]> => {

  return httpClient<ConviteResponse[]>(getAmbienteControllerListarConvitesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAmbienteControllerListarConvitesQueryKey = () => {
    return [
    `/v1/ambiente/convites`
    ] as const;
    }


export const getAmbienteControllerListarConvitesQueryOptions = <TData = Awaited<ReturnType<typeof ambienteControllerListarConvites>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerListarConvites>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAmbienteControllerListarConvitesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof ambienteControllerListarConvites>>> = ({ signal }) => ambienteControllerListarConvites({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerListarConvites>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AmbienteControllerListarConvitesQueryResult = NonNullable<Awaited<ReturnType<typeof ambienteControllerListarConvites>>>
export type AmbienteControllerListarConvitesQueryError = unknown


export function useAmbienteControllerListarConvites<TData = Awaited<ReturnType<typeof ambienteControllerListarConvites>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerListarConvites>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ambienteControllerListarConvites>>,
          TError,
          Awaited<ReturnType<typeof ambienteControllerListarConvites>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAmbienteControllerListarConvites<TData = Awaited<ReturnType<typeof ambienteControllerListarConvites>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerListarConvites>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ambienteControllerListarConvites>>,
          TError,
          Awaited<ReturnType<typeof ambienteControllerListarConvites>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAmbienteControllerListarConvites<TData = Awaited<ReturnType<typeof ambienteControllerListarConvites>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerListarConvites>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os convites pendentes/expirados do ambiente
 */

export function useAmbienteControllerListarConvites<TData = Awaited<ReturnType<typeof ambienteControllerListarConvites>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerListarConvites>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAmbienteControllerListarConvitesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAmbienteControllerCriarConviteUrl = () => {




  return `/v1/ambiente/convites`
}

/**
 * @summary Convida um e-mail (sem conta) para o ambiente, com um cargo
 */
export const ambienteControllerCriarConvite = async (criarConviteDto: CriarConviteDto, options?: Parameters<typeof httpClient>[1]): Promise<ConviteResponse[]> => {

  return httpClient<ConviteResponse[]>(getAmbienteControllerCriarConviteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarConviteDto)
  }
);}





export const getAmbienteControllerCriarConviteMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerCriarConvite>>, TError,{data: CriarConviteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerCriarConvite>>, TError,{data: CriarConviteDto}, TContext> => {

const mutationKey = ['ambienteControllerCriarConvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ambienteControllerCriarConvite>>, {data: CriarConviteDto}> = (props) => {
          const {data} = props ?? {};

          return  ambienteControllerCriarConvite(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AmbienteControllerCriarConviteMutationResult = NonNullable<Awaited<ReturnType<typeof ambienteControllerCriarConvite>>>
    export type AmbienteControllerCriarConviteMutationBody = CriarConviteDto
    export type AmbienteControllerCriarConviteMutationError = ErroResponse

    /**
 * @summary Convida um e-mail (sem conta) para o ambiente, com um cargo
 */
export const useAmbienteControllerCriarConvite = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerCriarConvite>>, TError,{data: CriarConviteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ambienteControllerCriarConvite>>,
        TError,
        {data: CriarConviteDto},
        TContext
      > => {
      return useMutation(getAmbienteControllerCriarConviteMutationOptions(options), queryClient);
    }
    export const getAmbienteControllerReenviarConviteUrl = (id: string,) => {




  return `/v1/ambiente/convites/${id}/reenviar`
}

/**
 * @summary Renova o prazo e reenvia o e-mail do convite
 */
export const ambienteControllerReenviarConvite = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<ConviteResponse[]> => {

  return httpClient<ConviteResponse[]>(getAmbienteControllerReenviarConviteUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAmbienteControllerReenviarConviteMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerReenviarConvite>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerReenviarConvite>>, TError,{id: string}, TContext> => {

const mutationKey = ['ambienteControllerReenviarConvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ambienteControllerReenviarConvite>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  ambienteControllerReenviarConvite(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AmbienteControllerReenviarConviteMutationResult = NonNullable<Awaited<ReturnType<typeof ambienteControllerReenviarConvite>>>

    export type AmbienteControllerReenviarConviteMutationError = ErroResponse

    /**
 * @summary Renova o prazo e reenvia o e-mail do convite
 */
export const useAmbienteControllerReenviarConvite = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerReenviarConvite>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ambienteControllerReenviarConvite>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getAmbienteControllerReenviarConviteMutationOptions(options), queryClient);
    }
    export const getAmbienteControllerRevogarConviteUrl = (id: string,) => {




  return `/v1/ambiente/convites/${id}`
}

/**
 * @summary Revoga um convite pendente
 */
export const ambienteControllerRevogarConvite = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getAmbienteControllerRevogarConviteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAmbienteControllerRevogarConviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerRevogarConvite>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerRevogarConvite>>, TError,{id: string}, TContext> => {

const mutationKey = ['ambienteControllerRevogarConvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ambienteControllerRevogarConvite>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  ambienteControllerRevogarConvite(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AmbienteControllerRevogarConviteMutationResult = NonNullable<Awaited<ReturnType<typeof ambienteControllerRevogarConvite>>>

    export type AmbienteControllerRevogarConviteMutationError = unknown

    /**
 * @summary Revoga um convite pendente
 */
export const useAmbienteControllerRevogarConvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerRevogarConvite>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ambienteControllerRevogarConvite>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getAmbienteControllerRevogarConviteMutationOptions(options), queryClient);
    }
    export const getAmbienteControllerListarCargosUrl = () => {




  return `/v1/ambiente/cargos`
}

/**
 * @summary Cargos deste ambiente + o cargo de sistema atribuível (`medico`)
 */
export const ambienteControllerListarCargos = async ( options?: Parameters<typeof httpClient>[1]): Promise<CargoDoAmbienteResponse[]> => {

  return httpClient<CargoDoAmbienteResponse[]>(getAmbienteControllerListarCargosUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAmbienteControllerListarCargosQueryKey = () => {
    return [
    `/v1/ambiente/cargos`
    ] as const;
    }


export const getAmbienteControllerListarCargosQueryOptions = <TData = Awaited<ReturnType<typeof ambienteControllerListarCargos>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerListarCargos>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAmbienteControllerListarCargosQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof ambienteControllerListarCargos>>> = ({ signal }) => ambienteControllerListarCargos({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerListarCargos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AmbienteControllerListarCargosQueryResult = NonNullable<Awaited<ReturnType<typeof ambienteControllerListarCargos>>>
export type AmbienteControllerListarCargosQueryError = unknown


export function useAmbienteControllerListarCargos<TData = Awaited<ReturnType<typeof ambienteControllerListarCargos>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerListarCargos>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ambienteControllerListarCargos>>,
          TError,
          Awaited<ReturnType<typeof ambienteControllerListarCargos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAmbienteControllerListarCargos<TData = Awaited<ReturnType<typeof ambienteControllerListarCargos>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerListarCargos>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ambienteControllerListarCargos>>,
          TError,
          Awaited<ReturnType<typeof ambienteControllerListarCargos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAmbienteControllerListarCargos<TData = Awaited<ReturnType<typeof ambienteControllerListarCargos>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerListarCargos>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Cargos deste ambiente + o cargo de sistema atribuível (`medico`)
 */

export function useAmbienteControllerListarCargos<TData = Awaited<ReturnType<typeof ambienteControllerListarCargos>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerListarCargos>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAmbienteControllerListarCargosQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAmbienteControllerCriarCargoUrl = () => {




  return `/v1/ambiente/cargos`
}

/**
 * @summary Cria um cargo próprio do ambiente
 */
export const ambienteControllerCriarCargo = async (criarCargoDoAmbienteDto: CriarCargoDoAmbienteDto, options?: Parameters<typeof httpClient>[1]): Promise<CargoDoAmbienteResponse[]> => {

  return httpClient<CargoDoAmbienteResponse[]>(getAmbienteControllerCriarCargoUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarCargoDoAmbienteDto)
  }
);}





export const getAmbienteControllerCriarCargoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerCriarCargo>>, TError,{data: CriarCargoDoAmbienteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerCriarCargo>>, TError,{data: CriarCargoDoAmbienteDto}, TContext> => {

const mutationKey = ['ambienteControllerCriarCargo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ambienteControllerCriarCargo>>, {data: CriarCargoDoAmbienteDto}> = (props) => {
          const {data} = props ?? {};

          return  ambienteControllerCriarCargo(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AmbienteControllerCriarCargoMutationResult = NonNullable<Awaited<ReturnType<typeof ambienteControllerCriarCargo>>>
    export type AmbienteControllerCriarCargoMutationBody = CriarCargoDoAmbienteDto
    export type AmbienteControllerCriarCargoMutationError = ErroResponse

    /**
 * @summary Cria um cargo próprio do ambiente
 */
export const useAmbienteControllerCriarCargo = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerCriarCargo>>, TError,{data: CriarCargoDoAmbienteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ambienteControllerCriarCargo>>,
        TError,
        {data: CriarCargoDoAmbienteDto},
        TContext
      > => {
      return useMutation(getAmbienteControllerCriarCargoMutationOptions(options), queryClient);
    }
    export const getAmbienteControllerCatalogoDePermissoesUrl = () => {




  return `/v1/ambiente/cargos/catalogo-permissoes`
}

/**
 * @summary Permissões que o médico pode marcar num cargo do ambiente
 */
export const ambienteControllerCatalogoDePermissoes = async ( options?: Parameters<typeof httpClient>[1]): Promise<CatalogoDePermissoesDoAmbienteResponse> => {

  return httpClient<CatalogoDePermissoesDoAmbienteResponse>(getAmbienteControllerCatalogoDePermissoesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAmbienteControllerCatalogoDePermissoesQueryKey = () => {
    return [
    `/v1/ambiente/cargos/catalogo-permissoes`
    ] as const;
    }


export const getAmbienteControllerCatalogoDePermissoesQueryOptions = <TData = Awaited<ReturnType<typeof ambienteControllerCatalogoDePermissoes>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerCatalogoDePermissoes>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAmbienteControllerCatalogoDePermissoesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof ambienteControllerCatalogoDePermissoes>>> = ({ signal }) => ambienteControllerCatalogoDePermissoes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerCatalogoDePermissoes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AmbienteControllerCatalogoDePermissoesQueryResult = NonNullable<Awaited<ReturnType<typeof ambienteControllerCatalogoDePermissoes>>>
export type AmbienteControllerCatalogoDePermissoesQueryError = unknown


export function useAmbienteControllerCatalogoDePermissoes<TData = Awaited<ReturnType<typeof ambienteControllerCatalogoDePermissoes>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerCatalogoDePermissoes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ambienteControllerCatalogoDePermissoes>>,
          TError,
          Awaited<ReturnType<typeof ambienteControllerCatalogoDePermissoes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAmbienteControllerCatalogoDePermissoes<TData = Awaited<ReturnType<typeof ambienteControllerCatalogoDePermissoes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerCatalogoDePermissoes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ambienteControllerCatalogoDePermissoes>>,
          TError,
          Awaited<ReturnType<typeof ambienteControllerCatalogoDePermissoes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAmbienteControllerCatalogoDePermissoes<TData = Awaited<ReturnType<typeof ambienteControllerCatalogoDePermissoes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerCatalogoDePermissoes>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Permissões que o médico pode marcar num cargo do ambiente
 */

export function useAmbienteControllerCatalogoDePermissoes<TData = Awaited<ReturnType<typeof ambienteControllerCatalogoDePermissoes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambienteControllerCatalogoDePermissoes>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAmbienteControllerCatalogoDePermissoesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAmbienteControllerAtualizarCargoUrl = (id: string,) => {




  return `/v1/ambiente/cargos/${id}`
}

/**
 * @summary Renomeia / redescreve um cargo do ambiente
 */
export const ambienteControllerAtualizarCargo = async (id: string,
    atualizarCargoDoAmbienteDto: AtualizarCargoDoAmbienteDto, options?: Parameters<typeof httpClient>[1]): Promise<CargoDoAmbienteResponse[]> => {

  return httpClient<CargoDoAmbienteResponse[]>(getAmbienteControllerAtualizarCargoUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarCargoDoAmbienteDto)
  }
);}





export const getAmbienteControllerAtualizarCargoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerAtualizarCargo>>, TError,{id: string;data: AtualizarCargoDoAmbienteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerAtualizarCargo>>, TError,{id: string;data: AtualizarCargoDoAmbienteDto}, TContext> => {

const mutationKey = ['ambienteControllerAtualizarCargo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ambienteControllerAtualizarCargo>>, {id: string;data: AtualizarCargoDoAmbienteDto}> = (props) => {
          const {id,data} = props ?? {};

          return  ambienteControllerAtualizarCargo(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AmbienteControllerAtualizarCargoMutationResult = NonNullable<Awaited<ReturnType<typeof ambienteControllerAtualizarCargo>>>
    export type AmbienteControllerAtualizarCargoMutationBody = AtualizarCargoDoAmbienteDto
    export type AmbienteControllerAtualizarCargoMutationError = ErroResponse

    /**
 * @summary Renomeia / redescreve um cargo do ambiente
 */
export const useAmbienteControllerAtualizarCargo = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerAtualizarCargo>>, TError,{id: string;data: AtualizarCargoDoAmbienteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ambienteControllerAtualizarCargo>>,
        TError,
        {id: string;data: AtualizarCargoDoAmbienteDto},
        TContext
      > => {
      return useMutation(getAmbienteControllerAtualizarCargoMutationOptions(options), queryClient);
    }
    export const getAmbienteControllerExcluirCargoUrl = (id: string,) => {




  return `/v1/ambiente/cargos/${id}`
}

/**
 * @summary Exclui um cargo do ambiente. Recusa se tem membro ou convite.
 */
export const ambienteControllerExcluirCargo = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getAmbienteControllerExcluirCargoUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAmbienteControllerExcluirCargoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerExcluirCargo>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerExcluirCargo>>, TError,{id: string}, TContext> => {

const mutationKey = ['ambienteControllerExcluirCargo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ambienteControllerExcluirCargo>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  ambienteControllerExcluirCargo(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AmbienteControllerExcluirCargoMutationResult = NonNullable<Awaited<ReturnType<typeof ambienteControllerExcluirCargo>>>

    export type AmbienteControllerExcluirCargoMutationError = ErroResponse

    /**
 * @summary Exclui um cargo do ambiente. Recusa se tem membro ou convite.
 */
export const useAmbienteControllerExcluirCargo = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerExcluirCargo>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ambienteControllerExcluirCargo>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getAmbienteControllerExcluirCargoMutationOptions(options), queryClient);
    }
    export const getAmbienteControllerDefinirPermissoesUrl = (id: string,) => {




  return `/v1/ambiente/cargos/${id}/permissoes`
}

/**
 * @summary Substitui o conjunto de permissões do cargo do ambiente
 */
export const ambienteControllerDefinirPermissoes = async (id: string,
    definirPermissoesDoAmbienteDto: DefinirPermissoesDoAmbienteDto, options?: Parameters<typeof httpClient>[1]): Promise<CargoDoAmbienteResponse[]> => {

  return httpClient<CargoDoAmbienteResponse[]>(getAmbienteControllerDefinirPermissoesUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(definirPermissoesDoAmbienteDto)
  }
);}





export const getAmbienteControllerDefinirPermissoesMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerDefinirPermissoes>>, TError,{id: string;data: DefinirPermissoesDoAmbienteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerDefinirPermissoes>>, TError,{id: string;data: DefinirPermissoesDoAmbienteDto}, TContext> => {

const mutationKey = ['ambienteControllerDefinirPermissoes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ambienteControllerDefinirPermissoes>>, {id: string;data: DefinirPermissoesDoAmbienteDto}> = (props) => {
          const {id,data} = props ?? {};

          return  ambienteControllerDefinirPermissoes(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AmbienteControllerDefinirPermissoesMutationResult = NonNullable<Awaited<ReturnType<typeof ambienteControllerDefinirPermissoes>>>
    export type AmbienteControllerDefinirPermissoesMutationBody = DefinirPermissoesDoAmbienteDto
    export type AmbienteControllerDefinirPermissoesMutationError = ErroResponse

    /**
 * @summary Substitui o conjunto de permissões do cargo do ambiente
 */
export const useAmbienteControllerDefinirPermissoes = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambienteControllerDefinirPermissoes>>, TError,{id: string;data: DefinirPermissoesDoAmbienteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ambienteControllerDefinirPermissoes>>,
        TError,
        {id: string;data: DefinirPermissoesDoAmbienteDto},
        TContext
      > => {
      return useMutation(getAmbienteControllerDefinirPermissoesMutationOptions(options), queryClient);
    }
